// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import almEntity from './entities/alm.json';
import almMenu from '../pages/alm/menu.json';
import almFullForm from '../pages/alm/forms/full.json';
import almContextForm from '../pages/alm/forms/context.json';
import almMiniForm from '../pages/alm/forms/mini.json';
import almLookupForm from '../pages/alm/forms/lookup.json';
import almTableView from '../pages/alm/views/table.json';
import almStagesView from '../pages/alm/views/stages.json';
import almCardsView from '../pages/alm/views/cards.json';
import almInlineView from '../pages/alm/views/inline.json';
import almBacklogView from '../pages/alm/views/backlog.json';
import almSplitView from '../pages/alm/views/split.json';
import almCalendarView from '../pages/alm/views/calendar.json';
import almDashboardView from '../pages/alm/views/dashboard.json';

/** Тип запису «Застосунок» зі сторінками пакета: меню, форми та подання з pages/alm/. */
export const almDefinition: IRecordTypeDefinition = {
  ...almEntity,
  views: assembleViewSet({
      table: almTableView,
      stages: almStagesView,
      cards: almCardsView,
      inline: almInlineView,
      backlog: almBacklogView,
      split: almSplitView,
      calendar: almCalendarView,
      dashboard: almDashboardView,
  }),
  form: almFullForm,
  forms: { full: almFullForm, context: almContextForm, mini: almMiniForm, lookup: almLookupForm },
  menu: almMenu,
} as IRecordTypeDefinition;
